import { filterTypesEnum, type FilterOption } from "@/types/common/filters";

// Map API status to display status
export const mapStatusToDisplay = (
  status: string,
): "Borrador" | "Publicada" | "Despublicada" | "Archivada" => {
  switch (status) {
    case "draft":
      return "Borrador";
    case "published":
      return "Publicada";
    case "unpublished":
      return "Despublicada";
    case "archived":
      return "Archivada";
    default:
      return "Borrador";
  }
};

// Map display status to API status
export const mapDisplayToApiStatus = (
  status: string,
): "draft" | "published" | "unpublished" | "archived" => {
  switch (status) {
    case "Borrador":
      return "draft";
    case "Publicada":
      return "published";
    case "Despublicada":
      return "unpublished";
    case "Archivada":
      return "archived";
    default:
      return "draft";
  }
};

// Función para inicializar filtros basados en la URL
export const buildInitialFilters = (
  published_at: string | null,
  status: string | null,
): FilterOption[] => {
  const initialFilters: FilterOption[] = [
    {
      id: 1,
      field: "published_at",
      type: filterTypesEnum.dates,
      label: "Fecha de Publicación",
      isUpdated: !!published_at,
      shouldDisabledFutureDates: true,
      result: published_at || "",
    },
    {
      id: 2,
      field: "status",
      type: filterTypesEnum.status,
      label: "Estado de la notificación",
      isUpdated: !!status,
      result: status || "",
      status: [
        {
          field: "Borrador",
          label: "Borrador",
          value: status?.includes("Borrador") || false,
        },
        {
          field: "Publicada",
          label: "Publicada",
          value: status?.includes("Publicada") || false,
        },
        {
          field: "Archivada",
          label: "Archivada",
          value: status?.includes("Archivada") || false,
        },
      ],
    },
  ];
  return initialFilters;
};

export const getEmptyFilters = (): FilterOption[] => [
  {
    id: 1,
    field: "published_at",
    type: filterTypesEnum.dates,
    label: "Fecha de Publicación",
    shouldDisabledFutureDates: true,
    isUpdated: false,
    result: "",
  },
  {
    id: 2,
    field: "status",
    type: filterTypesEnum.status,
    label: "Estado de la notificación",
    isUpdated: false,
    result: "",
    status: [
      {
        field: "Borrador",
        label: "Borrador",
        value: false,
      },
      {
        field: "Publicada",
        label: "Publicada",
        value: false,
      },
      {
        field: "Archivada",
        label: "Archivada",
        value: false,
      },
    ],
  },
];

export const buildAnnouncementsParams = ({
  page,
  deferredQuery,
  status,
  published_at,
  order_by,
}: {
  page: number;
  deferredQuery: string;
  status: string | null;
  published_at: string | null;
  order_by: string | null;
}) => ({
  page,
  per_page: 20,
  ...(deferredQuery ? { search: deferredQuery } : {}),
  ...(status
    ? {
        status: status.includes(",")
          ? status
              .split(",")
              .map((s) => mapDisplayToApiStatus(s.trim()))
              .join(",")
          : mapDisplayToApiStatus(status),
      }
    : {}),
  ...(published_at ? { date_range: published_at } : {}),
  ...(order_by
    ? {
        sort_by: order_by.startsWith("!")
          ? (order_by.slice(1) as
              | "created_at"
              | "title"
              | "content"
              | "status"
              | "is_published"
              | "updated_at")
          : (order_by as
              | "created_at"
              | "title"
              | "content"
              | "status"
              | "is_published"
              | "updated_at"),
        sort_direction: order_by.startsWith("!")
          ? ("desc" as const)
          : ("asc" as const),
      }
    : {}),
});
